// src/pages/TakeTest.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const TEST_OPTIONS = [
  {
    id: "diagnostic",
    icon: "🎯",
    title: "Diagnostic test",
    desc: "10 balanced questions across all subjects",
    subject: "",
  },
  {
    id: "weak-practice",
    icon: "⚡",
    title: "Practice weak topics",
    desc: "Adaptive questions from your weak areas",
    subject: "",
  },
  {
    id: "sectional",
    icon: "📐",
    title: "Quant sectional",
    desc: "10 questions — Quantitative Aptitude only",
    subject: "Quant",
  },
  {
    id: "sectional-r",
    icon: "🧩",
    title: "Reasoning sectional",
    desc: "10 questions — Verbal & Non-verbal Reasoning",
    subject: "Reasoning",
  },
  {
    id: "sectional-e",
    icon: "📖",
    title: "English sectional",
    desc: "10 questions — Grammar, Vocabulary & RC",
    subject: "English",
  },
];

export default function TakeTest() {
  const navigate  = useNavigate();
  function startTest(opt) {
    // Pass config via sessionStorage
    sessionStorage.setItem("testConfig", JSON.stringify({
      testType: opt.id.startsWith("sectional") ? "sectional" : opt.id,
      subject:  opt.subject,
      limit:    10,
    }));
    navigate("/test/session");
  }

  return (
    <div>
      <h1 className="page-title">Take a test</h1>
      <p className="page-sub">Select a test type and start your 10-question session</p>

      {TEST_OPTIONS.map(opt => (
        <div
          key={opt.id}
          style={{
            display: "flex", alignItems: "center", gap: 14,
            padding: "15px 18px",
            borderRadius: "var(--radius-lg)",
            border: `1.5px solid var(--border)`,
            background: "var(--surface)",
            marginBottom: 10,
            transition: "all .13s",
            boxShadow: "var(--shadow-sm)"
          }}
        >
          {/* Icon */}
          <div style={{ width: 44, height: 44, borderRadius: 12, background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
            {opt.icon}
          </div>

          {/* Text */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 2 }}>{opt.title}</div>
            <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>{opt.desc}</div>
          </div>

          {/* Action Button */}
          <button 
            className="btn btn-blue btn-sm" 
            onClick={() => startTest(opt)}
            style={{ borderRadius: 8, padding: "8px 16px" }}
          >
            Start
          </button>
        </div>
      ))}

      <div style={{ marginTop: 20 }}>
        <button className="btn" onClick={() => navigate("/")}>Cancel</button>
      </div>
    </div>
  );
}
